/**
 * Tipos de dominio para masters de proveedores (espejo de `modules/catalog/infra/suppliersRepo`).
 * Cualquier cambio en columnas / forma de `SupplierRecord` u operaciones relacionadas en ese repo
 * debe reflejarse aquí para mantener el contrato del módulo Catálogo.
 */

export type SupplierRecord = {
  id: string;
  organizationId: string;
  name: string;
  code: string | null;
  taxId: string | null;
  contactName: string | null;
  contactEmail: string | null;
  contactPhone: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  paymentTerms: string | null;
  leadTimeDays: number | null;
  minimumOrderAmount: number | null;
  website: string | null;
  notes: string | null;
  accountNumber: string | null;
  isActive: boolean;
  deletedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
};

export type SupplierFilterState = 'all' | 'active' | 'inactive';

/**
 * Plazos de pago soportados — espeja el CHECK `chk_suppliers_payment_terms`
 * (15_days … 90_days, cash_on_delivery, prepaid, other). La UI muestra el
 * `label` legible; el `value` crudo es lo que se persiste.
 */
export const SUPPLIER_PAYMENT_TERMS = [
  { value: '15_days', label: '15 días' },
  { value: '30_days', label: '30 días' },
  { value: '45_days', label: '45 días' },
  { value: '60_days', label: '60 días' },
  { value: '90_days', label: '90 días' },
  { value: 'cash_on_delivery', label: 'Contraentrega' },
  { value: 'prepaid', label: 'Pago anticipado' },
  { value: 'other', label: 'Otro' },
] as const;

/** Label legible del enum; devuelve el valor crudo si es un valor viejo/custom. */
export function supplierPaymentTermsLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  const hit = SUPPLIER_PAYMENT_TERMS.find((t) => t.value === value);
  return hit ? hit.label : value;
}

export type CreateSupplierParams = {
  name: string;
  code?: string | null;
  taxId?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  paymentTerms?: string | null;
  leadTimeDays?: number | null;
  minimumOrderAmount?: number | null;
  website?: string | null;
  notes?: string | null;
  accountNumber?: string | null;
  isActive?: boolean;
};

export type UpdateSupplierParams = {
  id: string;
  name: string;
  code?: string | null;
  taxId?: string | null;
  contactName?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  paymentTerms?: string | null;
  leadTimeDays?: number | null;
  minimumOrderAmount?: number | null;
  website?: string | null;
  notes?: string | null;
  accountNumber?: string | null;
  isActive?: boolean;
};
